import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
} from "@mui/material";
import {
  StyledTableCellValueTemplate,
  StyledTableCellLabelTemplate,
  LabelTemplate,
  StyledTableRowTemplate,
  StyledTableContainer,
} from "../../styles/table";
import {
  CookingExperience,
  Employee,
  Skills,
} from "../../../types/processTypes";
import { tt } from "../../../../../data/langUtility";
import { Check, Close } from "@mui/icons-material";
import { BasicRate } from "./BasicRate";

interface Props {
  currentEmployee: Employee;
  template: LabelTemplate;
  includeIroning?: boolean | false;
}
export const BasicSkills = ({ currentEmployee, template }: Props) => {
  return (
    <>
      {currentEmployee.education && currentEmployee.education.skills && (
        <StyledTableContainer
          template={template}
          sx={{
            marginTop: template.spacing,
          }}
        >
          <Table size="small" aria-label="simple table">
            <TableHead>
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellLabelTemplate
                  template={template}
                  colSpan={2}
                  sx={{ textAlign: "left" }}
                >
                  {tt("skills", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("skills", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            </TableHead>
            <TableBody>
              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("washing_dishes", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_dishes,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("washing_dishes", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("washing_ironing_clothes", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_ironing_clothes,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("washing_ironing_clothes", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("dusting_cleaning", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.dusting_cleaning,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("dusting_cleaning", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("baby_sitting", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.baby_sitting,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("baby_sitting", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("cooking", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(Skills.cooking) >
                  -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("cooking", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("arabic_cooking", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.arabic_cooking,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("arabic_cooking", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="5">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("children_care", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.children_care,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("children_care", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="5">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("sewing", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(Skills.sewing) >
                  -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("sewing", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="7">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("other_skills", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education.remarks}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("other_skills", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            </TableBody>
          </Table>
        </StyledTableContainer>
      )}
    </>
  );
};
export const BasicSkillsTwoRows = ({ currentEmployee, template }: Props) => {
  return (
    <>
      {currentEmployee.education && currentEmployee.education.skills && (
        <StyledTableContainer
          template={template}
          sx={{
            marginTop: template.spacing,
          }}
        >
          <Table size="small" aria-label="simple table">
            <TableHead>
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellLabelTemplate
                  template={template}
                  colSpan={3}
                  sx={{ textAlign: "left" }}
                >
                  {tt("skills", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  colSpan={3}
                  sx={{ textAlign: "right" }}
                >
                  {tt("skills", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            </TableHead>
            <TableBody>
              <StyledTableRowTemplate template={template} key="10">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("washing_dishes", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_dishes,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("washing_dishes", "ar")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("washing_ironing_clothes", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_ironing_clothes,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("washing_ironing_clothes", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("dusting_cleaning", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.dusting_cleaning,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("dusting_cleaning", "ar")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("baby_sitting", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.baby_sitting,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("baby_sitting", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("cooking", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(Skills.cooking) >
                  -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("cooking", "ar")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("arabic_cooking", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.arabic_cooking,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("arabic_cooking", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="5">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("children_care", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.children_care,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("children_care", "ar")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("sewing", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(Skills.sewing) >
                  -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("sewing", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="7">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("other_skills", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  colSpan={4}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education.remarks &&
                  currentEmployee.education.remarks.length > 2
                    ? currentEmployee.education.remarks
                    : tt("willing_to_learn", template.cvLang)}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("other_skills", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            </TableBody>
          </Table>
        </StyledTableContainer>
      )}
    </>
  );
};
export const BasicSkillsSmallHorz = ({ currentEmployee, template }: Props) => {
  return (
    <>
      {currentEmployee.education && currentEmployee.education.skills && (
        <StyledTableContainer
          template={template}
          sx={{
            marginTop: template.spacing,
          }}
        >
          <Table size="small" aria-label="simple table">
            <TableHead>
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellLabelTemplate
                  colSpan={2}
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("skills", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("skills", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            </TableHead>
            <TableBody>
              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("washing_dishes", "ar")}
                  <br />
                  {tt("washing_dishes", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("washing_ironing_clothes", "ar")}
                  <br />
                  {tt("washing_ironing_clothes", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("dusting_cleaning", "ar")}
                  <br />
                  {tt("dusting_cleaning", "en")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="10">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_dishes,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_ironing_clothes,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.dusting_cleaning,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("baby_sitting", "ar")}
                  <br />
                  {tt("baby_sitting", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("cooking", "ar")}
                  <br />
                  {tt("cooking", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("arabic_cooking", "ar")}
                  <br />
                  {tt("arabic_cooking", "en")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="11">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.baby_sitting,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(Skills.cooking) >
                  -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.arabic_cooking,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="5">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("children_care", "ar")}
                  <br />
                  {tt("children_care", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("sewing", "ar")}
                  <br />
                  {tt("sewing", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                ></StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="55">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.children_care,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(Skills.sewing) >
                  -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                ></StyledTableCellValueTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="7">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("other_skills", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  colSpan={2}
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education.remarks &&
                  currentEmployee.education.remarks.length > 2
                    ? currentEmployee.education.remarks
                    : tt("willing_to_learn", template.cvLang)}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
            </TableBody>
          </Table>
        </StyledTableContainer>
      )}
    </>
  );
};
export const BasicSkillsSmallHorzTwoLines = ({
  currentEmployee,
  template,
}: Props) => {
  return (
    <>
      {currentEmployee.education && currentEmployee.education.skills && (
        <StyledTableContainer
          template={template}
          sx={{
            marginTop: template.spacing,
          }}
        >
          <Table size="small" aria-label="simple table">
            <TableHead>
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellLabelTemplate
                  colSpan={2}
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("skills", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("skills", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            </TableHead>
            <TableBody>
              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("washing_dishes", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("washing_ironing_clothes", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("dusting_cleaning", "en")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="10">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_dishes,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_ironing_clothes,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.dusting_cleaning,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("baby_sitting", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("cooking", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("children_care", "en")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="11">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.baby_sitting,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(Skills.cooking) >
                  -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.children_care,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
            </TableBody>
          </Table>
        </StyledTableContainer>
      )}
    </>
  );
};
export const BasicSkillsSmallHorzTwoLinesTwoLang = ({
  currentEmployee,
  template,
}: Props) => {
  return (
    <>
      {currentEmployee.education && currentEmployee.education.skills && (
        <StyledTableContainer
          template={template}
          sx={{
            marginTop: template.spacing,
          }}
        >
          <Table size="small" aria-label="simple table">
            <TableHead>
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellLabelTemplate
                  colSpan={2}
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("skills", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("skills", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            </TableHead>
            <TableBody>
              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("washing_dishes", "en")}
                  <br />
                  {tt("washing_dishes", "ar")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("washing_ironing_clothes", "en")}
                  <br />
                  {tt("washing_ironing_clothes", "ar")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("dusting_cleaning", "en")}
                  <br />
                  {tt("dusting_cleaning", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="10">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_dishes,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_ironing_clothes,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.dusting_cleaning,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("baby_sitting", "en")}
                  <br />
                  {tt("baby_sitting", "ar")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("cooking", "en")}
                  <br />
                  {tt("cooking", "ar")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("children_care", "en")}
                  <br />
                  {tt("children_care", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="11">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.baby_sitting,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(Skills.cooking) >
                  -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.children_care,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
            </TableBody>
          </Table>
        </StyledTableContainer>
      )}
    </>
  );
};
export const BasicSkillsOneLineHorz = ({
  currentEmployee,
  template,
  includeIroning = false,
}: Props) => {
  return (
    <>
      {currentEmployee.education && currentEmployee.education.skills && (
        <StyledTableContainer
          template={template}
          sx={{
            marginTop: template.spacing,
          }}
        >
          <Table size="small" aria-label="simple table">
            <TableHead>
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellLabelTemplate
                  colSpan={5}
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("skills", "en")} <br /> {tt("skills", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            </TableHead>
            <TableBody>
              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("baby_sitting", "en")} <br /> {tt("baby_sitting", "ar")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("dusting_cleaning", "en")} <br />{" "}
                  {tt("dusting_cleaning", "ar")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("washing_dishes", "en")} <br />{" "}
                  {tt("washing_dishes", "ar")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("cooking", "en")} <br /> {tt("cooking", "ar")}
                </StyledTableCellLabelTemplate>
                {includeIroning && (
                  <StyledTableCellLabelTemplate
                    template={template}
                    sx={{ textAlign: "center" }}
                  >
                    {tt("washing_ironing_clothes", "en")}{" "}
                    {tt("washing_ironing_clothes", "ar")}
                  </StyledTableCellLabelTemplate>
                )}
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.baby_sitting,
                  ) > -1
                    ? "GOOD"
                    : "Weak"}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.dusting_cleaning,
                  ) > -1
                    ? "GOOD"
                    : "Weak"}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_dishes,
                  ) > -1
                    ? "GOOD"
                    : "Weak"}
                </StyledTableCellValueTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt(
                    currentEmployee.education?.cooking as string,
                    template.cvLang,
                  )}
                </StyledTableCellValueTemplate>
                {includeIroning && (
                  <StyledTableCellValueTemplate
                    template={template}
                    sx={{ textAlign: "center" }}
                  >
                    {currentEmployee.education?.skills?.indexOf(
                      Skills.washing_ironing_clothes,
                    ) > -1
                      ? "GOOD"
                      : "Weak"}
                  </StyledTableCellValueTemplate>
                )}
              </StyledTableRowTemplate>
            </TableBody>
          </Table>
        </StyledTableContainer>
      )}
    </>
  );
};
export const BasicSkillsTwoLinesHorz = ({
  currentEmployee,
  template,
}: Props) => {
  return (
    <>
      {currentEmployee.education && currentEmployee.education.skills && (
        <StyledTableContainer
          template={template}
          sx={{
            marginTop: template.spacing,
          }}
        >
          <Table size="small" aria-label="simple table">
            <TableHead>
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellLabelTemplate
                  colSpan={5}
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("skills", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("skills", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            </TableHead>
            <TableBody>
              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("washing_dishes", "ar")}
                  <br />
                  {tt("washing_dishes", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("washing_ironing_clothes", "ar")}
                  <br />
                  {tt("washing_ironing_clothes", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("dusting_cleaning", "ar")}
                  <br />
                  {tt("dusting_cleaning", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("baby_sitting", "ar")}
                  <br />
                  {tt("baby_sitting", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("cooking", "ar")}
                  <br />
                  {tt("cooking", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("arabic_cooking", "ar")}
                  <br />
                  {tt("arabic_cooking", "en")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_dishes,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_ironing_clothes,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.dusting_cleaning,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.baby_sitting,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(Skills.cooking) >
                  -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.arabic_cooking,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="5">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("children_care", "ar")}
                  <br />
                  {tt("children_care", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("sewing", "ar")}
                  <br />
                  {tt("sewing", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  colSpan={4}
                  sx={{ textAlign: "center" }}
                >
                  {tt("other_skills", "ar")}
                  <br />
                  {tt("other_skills", "en")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="55">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.children_care,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(Skills.sewing) >
                  -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  colSpan={4}
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education.remarks &&
                  currentEmployee.education.remarks.length > 2
                    ? currentEmployee.education.remarks
                    : tt("willing_to_learn", template.cvLang)}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
            </TableBody>
          </Table>
        </StyledTableContainer>
      )}
    </>
  );
};
export const BasicSkillsVer = ({ currentEmployee, template }: Props) => {
  return (
    <>
      {currentEmployee.education && currentEmployee.education.skills && (
        <StyledTableContainer
          template={template}
          sx={{
            marginTop: template.spacing,
          }}
        >
          <Table size="small" aria-label="simple table">
            <TableHead>
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellLabelTemplate
                  colSpan={2}
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("skills", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("skills", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            </TableHead>
            <TableBody>
              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("washing_dishes", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("washing_dishes", "ar")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_dishes,
                  ) > -1
                    ? "YES"
                    : "FAIR"}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("washing_ironing_clothes", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("washing_ironing_clothes", "ar")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_ironing_clothes,
                  ) > -1
                    ? "YES"
                    : "FAIR"}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("dusting_cleaning", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("dusting_cleaning", "ar")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.dusting_cleaning,
                  ) > -1
                    ? "YES"
                    : "FAIR"}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("cooking", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("cooking", "ar")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt(
                    currentEmployee.education?.cooking as string,
                    template.cvLang,
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("baby_sitting", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("baby_sitting", "ar")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.baby_sitting,
                  ) > -1
                    ? "YES"
                    : "FAIR"}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="7">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("other_skills", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("other_skills", "ar")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education.remarks &&
                  currentEmployee.education.remarks.length > 2
                    ? currentEmployee.education.remarks
                    : tt("willing_to_learn", template.cvLang)}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
            </TableBody>
          </Table>
        </StyledTableContainer>
      )}
    </>
  );
};

export const BasicSkillsVerValue = ({ currentEmployee, template }: Props) => {
  return (
    <>
      {currentEmployee.education && currentEmployee.education.skills && (
        <StyledTableContainer
          template={template}
          sx={{
            marginTop: template.spacing,
          }}
        >
          <Table size="small" aria-label="simple table">
            <TableHead>
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("skills", "en")}
                  <br />
                  {tt("skills", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            </TableHead>
            <TableBody>
              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("washing_dishes", "ar")}
                  <br />
                  {tt("washing_dishes", "en")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_dishes,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("washing_ironing_clothes", "ar")}
                  <br />
                  {tt("washing_ironing_clothes", "en")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_ironing_clothes,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("dusting_cleaning", "ar")}
                  <br />
                  {tt("dusting_cleaning", "en")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.dusting_cleaning,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("baby_sitting", "ar")}
                  <br />
                  {tt("baby_sitting", "en")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.baby_sitting,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("cooking", "ar")}
                  <br />
                  {tt("cooking", "en")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(Skills.cooking) >
                  -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("arabic_cooking", "ar")}
                  <br />
                  {tt("arabic_cooking", "en")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.arabic_cooking,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="5">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("children_care", "ar")}
                  <br />
                  {tt("children_care", "en")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.children_care,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="5">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("sewing", "ar")}
                  <br />
                  {tt("sewing", "en")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(Skills.sewing) >
                  -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="7">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("other_skills", "en")}
                  <br />
                  {tt("other_skills", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education.remarks &&
                  currentEmployee.education.remarks.length > 2
                    ? currentEmployee.education.remarks
                    : tt("willing_to_learn", template.cvLang)}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
            </TableBody>
          </Table>
        </StyledTableContainer>
      )}
    </>
  );
};

export const BasicSkillsOneLineHorzStar = ({
  currentEmployee,
  template,
}: Props) => {
  return (
    <>
      {currentEmployee.education && currentEmployee.education.skills && (
        <StyledTableContainer
          template={template}
          sx={{
            marginTop: template.spacing,
          }}
        >
          <Table size="small" aria-label="simple table">
            <TableHead>
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellLabelTemplate
                  colSpan={6}
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("skills", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("skills", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            </TableHead>
            <TableBody>
              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("baby_sitting", "ar")}
                  <br />
                  {tt("baby_sitting", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("dusting_cleaning", "ar")}
                  <br />
                  {tt("dusting_cleaning", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("washing_ironing_clothes", "ar")}
                  <br />
                  {tt("washing_ironing_clothes", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("cooking", "ar")}
                  <br />
                  {tt("cooking", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("arabic_cooking", "ar")}
                  <br />
                  {tt("arabic_cooking", "en")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  <BasicRate
                    currentEmployee={currentEmployee}
                    template={template}
                    rateType="babySitting"
                  />
                </StyledTableCellValueTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  <BasicRate
                    currentEmployee={currentEmployee}
                    template={template}
                    rateType="cleaning"
                  />
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  <BasicRate
                    currentEmployee={currentEmployee}
                    template={template}
                    rateType="washing"
                  />
                </StyledTableCellValueTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  <BasicRate
                    currentEmployee={currentEmployee}
                    template={template}
                    rateType="cooking"
                  />
                </StyledTableCellValueTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  <BasicRate
                    currentEmployee={currentEmployee}
                    template={template}
                    rateType="arabic_cooking"
                  />
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
            </TableBody>
          </Table>
        </StyledTableContainer>
      )}
    </>
  );
};

export const BasicSkillsTwoLineHorzStar = ({
  currentEmployee,
  template,
}: Props) => {
  return (
    <>
      {currentEmployee.education && currentEmployee.education.skills && (
        <StyledTableContainer
          template={template}
          sx={{
            marginTop: template.spacing,
          }}
        >
          <Table size="small" aria-label="simple table">
            <TableHead>
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellLabelTemplate
                  colSpan={5}
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("skills", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("skills", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            </TableHead>
            <TableBody>
              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("baby_sitting", "ar")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("dusting_cleaning", "ar")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("washing_ironing_clothes", "ar")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("cooking", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  <BasicRate
                    currentEmployee={currentEmployee}
                    template={template}
                    rateType="babySitting"
                  />
                </StyledTableCellValueTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  <BasicRate
                    currentEmployee={currentEmployee}
                    template={template}
                    rateType="cleaning"
                  />
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  <BasicRate
                    currentEmployee={currentEmployee}
                    template={template}
                    rateType="washing"
                  />
                </StyledTableCellValueTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  <BasicRate
                    currentEmployee={currentEmployee}
                    template={template}
                    rateType="cooking"
                  />
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="120">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("baby_sitting", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("dusting_cleaning", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("washing_ironing_clothes", "en")}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt("cooking", "en")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            </TableBody>
          </Table>
        </StyledTableContainer>
      )}
    </>
  );
};

export const BasicSkillsNoLabels = ({ currentEmployee, template }: Props) => {
  return (
    <>
      {currentEmployee.education && currentEmployee.education.skills && (
        <StyledTableContainer
          template={template}
          sx={{
            marginTop: template.spacing,
          }}
        >
          <Table size="small" aria-label="simple table">
            <TableBody>
              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.dusting_cleaning,
                  ) > -1
                    ? "Good"
                    : "Weak"}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_dishes,
                  ) > -1
                    ? "Good"
                    : "Weak"}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_ironing_clothes,
                  ) > -1
                    ? "Good"
                    : "Weak"}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {tt(
                    currentEmployee.education?.cooking as string,
                    template.cvLang,
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
            </TableBody>
          </Table>
        </StyledTableContainer>
      )}
    </>
  );
};

export const BasicSkillsVerGolden = ({ currentEmployee, template }: Props) => {
  return (
    <>
      {currentEmployee.education && currentEmployee.education.skills && (
        <StyledTableContainer
          template={template}
          sx={{
            marginTop: template.spacing,
          }}
        >
          <Table size="small" aria-label="simple table">
            <TableHead>
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellLabelTemplate
                  colSpan={2}
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {"basic skills"}
                </StyledTableCellLabelTemplate>

                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("skills", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            </TableHead>
            <TableBody>
              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("washing_dishes", "en")}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_dishes,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("washing_dishes", "ar")}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("washing_ironing_clothes", "en")}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_ironing_clothes,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("washing_ironing_clothes", "ar")}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {tt("dusting_cleaning", "en")}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.dusting_cleaning,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("dusting_cleaning", "ar")}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {"Caring Children"}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.baby_sitting,
                  ) > -1 ? (
                    <Check />
                  ) : (
                    <Close />
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("baby_sitting", "ar")}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>

              <StyledTableRowTemplate template={template} key="7">
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "left" }}
                >
                  {"Additional Skills"}
                </StyledTableCellValueTemplate>

                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "center" }}
                >
                  {currentEmployee.education.remarks &&
                  currentEmployee.education.remarks.length > 2
                    ? currentEmployee.education.remarks
                    : tt("willing_to_learn", template.cvLang)}
                </StyledTableCellValueTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{ textAlign: "right" }}
                >
                  {tt("other_skills", "ar")}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
            </TableBody>
          </Table>
        </StyledTableContainer>
      )}
    </>
  );
};

export const BasicSkillsEnglishOnly = ({
  currentEmployee,
  template,
}: Props) => {
  return (
    <>
      {currentEmployee.education && currentEmployee.education.skills && (
        <StyledTableContainer
          template={template}
          sx={{
            marginTop: template.spacing,
          }}
        >
          <Table size="small" aria-label="simple table">
            <TableHead>
              <StyledTableRowTemplate template={template}>
                <StyledTableCellLabelTemplate template={template} colSpan={2}>
                  JOB STATUS & ABILITY
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            </TableHead>
            <TableBody>
              <StyledTableRowTemplate template={template}>
                <StyledTableCellLabelTemplate template={template}>
                  COOKING
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {(currentEmployee.education?.cooking as string) ===
                    CookingExperience.good ||
                  (currentEmployee.education?.cooking as string) ===
                    CookingExperience.excellent
                    ? "YES"
                    : (currentEmployee.education?.cooking as string) ===
                        CookingExperience.fair
                      ? "FAIR"
                      : "NO"}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template}>
                <StyledTableCellLabelTemplate template={template}>
                  BABY SITTING
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.baby_sitting,
                  ) > -1
                    ? "YES"
                    : "NO"}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template}>
                <StyledTableCellLabelTemplate template={template}>
                  CLEANING
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.dusting_cleaning,
                  ) > -1
                    ? "YES"
                    : "NO"}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template}>
                <StyledTableCellLabelTemplate template={template}>
                  IRONING
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {currentEmployee.education?.skills?.indexOf(
                    Skills.washing_ironing_clothes,
                  ) > -1
                    ? "YES"
                    : "NO"}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template}>
                <StyledTableCellLabelTemplate template={template}>
                  DRIVING
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  NO
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
              <StyledTableRowTemplate template={template}>
                <StyledTableCellLabelTemplate template={template}>
                  SEWING
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {currentEmployee.education?.skills?.indexOf(Skills.sewing) >
                  -1
                    ? "YES"
                    : "NO"}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
            </TableBody>
          </Table>
        </StyledTableContainer>
      )}
    </>
  );
};
